export const Frequencies = {
  1: _TL_('Daily'),
  2: _TL_('Weekly'),
  3: _TL_('Monthly'),
};
